import React from "react";
import CorePopOver from "../../layouts/CorePopOver";
import CoreTypographyBody1 from "../CoreTypographyBody1";
import { Box } from "@mui/material";
import { theme } from "../../../config/theme";

export default function ActionPopOver({
  rowActions,
  anchorEl,
  handlePopoverClose,
  handlePopoverOpen,
  ...restProps
}) {
  return (
    rowActions &&
    rowActions?.length > 0 && (
      <CorePopOver
        id="mouse-over-popover"
        open={anchorEl ? true : false}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Box
          id="datatable-action-container"
          style={{
            padding: 2,
            backgroundColor: theme.palette.background.paper,
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          {restProps.children}
        </Box>
      </CorePopOver>
    )
  );
}
